export const TITLE_CONFIG = {
  en: {
    // ATLAS CMS

    // Dashboard
    '/cms/dashboard': 'Dashboard',
    '/cms/vfodashboard': 'VFO Dashboard',
    // Trailer Workflow
    '/trailerworkflow': 'Trailer Vorkflow',

    // VOD OPERATIONS

    // Deal Management
    '/dealing/provider': 'Provider Management',
    '/dealing/content': 'Content Management',
    // Vod Contents
    '/vod/list': 'Vod Contents',
    // Vod Content Groups
    '/vod/listgroup': 'Vod Content Groups',
    // Content Planning
    '/mp/planning': 'Content Planning',
    '/mp/publish': 'Ready For Publish Content',
    '/mp/unpublish': 'Published',
    // Category Management
    '/client/categorydefinition': 'Category Definition',
    // Content Validation
    '/validation/management': 'Validation Management',
    '/cms/vod/validation/contentissuetypes': 'Content Issue Types',
    '/vod/validation/contentissuetypescount': 'Content Issue Types Count',
    '/vod/validation/activitylogs': 'Validation Event Activity Log',
    // LTV OPERATİONS

    // Ltv Contents
    '/cms/ltv/channel': 'Ltv Channels',
    '/cms/ltv/ltvgroups': 'Ltv Channel Groups',
    '/cms/ltv/epgman': 'Epg Management',
    '/cms/ltv/epgman/epg-editor': 'Epg Editor',
    '/cms/ltv/epgman/update-epg': 'Update Channel Epg',
    '/cms/ltv/epgman/epg-program-search': 'Search Epg Program',
    '/cms/ltv/epgman/epg-active-streams': 'Epg Active Stream',

    // BANNER MANAGEMENT

    '/cms/bannermanagement': 'Banner Management',

    // VIDEO DOWNLOADER

    '/cms/videodownloader': 'Video Downloader',

    // CMS CONFIGRUTION

    '/cms/config/operator': 'Third Party Agency',
    '/cms/config/operator/posterdef': 'Poster Definitions',
    '/cms/config/operator/epgposterdef': 'Epg Poster Definitions',
    '/cms/config/operator/metadataenrichment': 'Metadata Custom Fields',
    '/cms/config/operator/genres': 'Genres',
    '/cms/config/operator/casts': 'Cast Management',
    '/cms/config/operator/autoprocessjobs': 'Auto Process Jobs',
    '/cms/config/operator/filterpreset': 'Filter Presets',
    '/cms/config/operator/specialcontents': '555 Contents',

    // Catchup Management
    '/cms/ltv/catchupsmanagement': 'Catchups',
    '/cms/ltv/catchupsmanagement/catchupsrequests': 'Catchup Requests',
    '/cms/ltv/catchupsmanagement/catchupstrim': 'Catchups Trim',

    // ATLAS ENCODE

    // Encoding Profiles
    '/encoding/profiles': 'Encoding Profiles',
    '/encoding/main': 'Encoding Stations',

    // ATLAS CRM

    // Customer Operations
    '/crm/dashboard': 'Customers',
    '/crm/customergroup/list': 'Customer Groups',
    // Product Management
    '/crm/product/list': 'Products',
    '/crm/product/detail': 'Package Contents',
    '/crm/campaign': 'Campaigns',

    // ATLAS ANALİYTCS

    //Usage Reports
    '/analytics/usage-reports/dashboard': 'Usage Reports Dashboard',
    '/analytics/usage-reports/vod-reports': 'VOD View Reports',
    '/analytics/usage-reports/ltv-reports': 'LTV Viewership Reports',
    '/analytics/usage-reports/login-reports': 'Login Counts By Device Types',
    //Revenue Reports
    '/analytics/revenue-reports/dashboard': 'Revenue Reports Dashboard',
    '/analytics/revenue-reports/customer-by-package': 'Customer Count by Package',
    '/analytics/revenue-reports/customer-revenue-by-package': 'Customer Revenue by Package',

    // ATLAS SUITE

    //User Management
    '/atlas/suite/users/list': 'Users',
    '/atlas/suite/users/sessions': 'Sessions',
    '/atlas/suite/audit': 'Audit Logs',
    '/atlas/suite/role': 'Authorization Management',
    '/atlas/suite/quick-links': 'Quick Links',
    '/atlas/suite/messages': 'Message Management',
    '/cms/config/atlasconfig': 'Configs',
  },
  ar: {
    // ATLAS CMS

    // Dashboard
    '/dashboard': 'لوحة التحكم',
    '/vfodashboard': 'لوحة تحكم VFO',
    // Trailer Workflow
    '/trailerworkflow': 'تدفق العمل للمقطورات',

    // Vod Operations

    // Deal Management
    '/dealing/provider': 'إدارة المزودين',
    '/dealing/content': 'إدارة المحتوى',
    // Vod Contents
    '/vod/list': 'محتويات الفيديو حسب الطلب',
    // Vod Content Groups
    '/vod/listgroup': 'مجموعات محتوى الفيديو حسب الطلب',
    // Content Planning
    '/mp/planning': 'تخطيط المحتوى',
    '/mp/publish': 'محتوى جاهز للنشر',
    '/mp/unpublish': 'منشور',
    // Category Management
    '/client/categorydefinition': 'تعريف الفئة',
    // Content Validation
    '/validation/management': 'إدارة التحقق',
    '/cms/vod/validation/contentissuetypes': 'أنواع مشاكل المحتوى',
    '/vod/validation/contentissuetypescount': 'عدد أنواع مشاكل المحتوى',
    '/vod/validation/activitylogs': 'سجل نشاط أحداث التحقق',

    // LTV OPERATİONS

    // Ltv Contents
    '/cms/ltv/channel': 'قنوات LTV',
    '/cms/ltv/ltvgroups': 'مجموعات محتوى LTV',
    '/cms/ltv/epgman': 'إدارة دليل البرامج',
    '/cms/ltv/epgman/epg-editor': 'محرر دليل البرامج',
    '/cms/ltv/epgman/update-epg': 'تحديث دليل البرامج',
    '/cms/ltv/epgman/epg-program-search': 'بحث في برامج دليل البرامج',
    '/cms/ltv/epgman/epg-active-streams': 'تدفقات EPG النشطة',

    // BANNER MANAGEMENT

    '/cms/bannermanagement': 'إدارة البنرات',

    // VIDEO DOWNLOADER

    '/cms/videodownloader': 'أداة تنزيل الفيديو',

    // CMS CONFIGRUTION

    '/cms/config/operator': 'وكالة الطرف الثالث',
    '/cms/config/operator/posterdef': 'تعريفات الملصقات',
    '/cms/config/operator/epgposterdef': 'تعريفات بوسترات دليل البرامج',
    '/cms/config/operator/metadataenrichment': 'حقول إثراء البيانات الوصفية',
    '/cms/config/operator/genres': 'الأنواع',
    '/cms/config/operator/casts': 'إدارة الممثلين',
    '/cms/config/operator/autoprocessjobs': 'وظائف المعالجة التلقائية',
    '/cms/config/operator/filterpreset': 'إعدادات الفلاتر',
    '/cms/config/operator/specialcontents': 'محتويات 555',

    // Catchup Management
    '/cms/ltv/catchupsmanagement': 'الإعادات',
    '/cms/ltv/catchupsmanagement/catchupsrequests': 'طلبات الإعادة',
    '/cms/ltv/catchupsmanagement/catchupstrim': 'اقتطاع الإعادات',

    // ATLAS ENCODE

    // Encoding Profiles
    '/encoding/profiles': 'ملفات الترميز',
    '/encoding/main': 'محطات الترميز',

    // ATLAS CRM

    // Customer Operations
    '/crm/dashboard': 'العملاء',
    '/crm/customergroup/list': 'مجموعات العملاء',
    // Product Management
    '/crm/product/list': 'المنتجات',
    '/crm/product/detail': 'محتويات الباقة',
    '/crm/campaign': 'الحملات',

    // ATLAS ANALYTCS

    // Usage Reports
    '/analytics/usage-reports/dashboard': 'لوحة تقارير الاستخدام',
    '/analytics/usage-reports/vod-reports': 'تقارير مشاهدات الفيديو حسب الطلب',
    '/analytics/usage-reports/ltv-reports': 'تقارير المشاهدة LTV',
    '/analytics/usage-reports/login-reports': 'عدد تسجيلات الدخول حسب نوع الجهاز',
    // Revenue Reports
    '/analytics/revenue-reports/dashboard': 'لوحة تقارير الإيرادات',
    '/analytics/revenue-reports/customer-by-package': 'عدد العملاء حسب الباقة',
    '/analytics/revenue-reports/customer-revenue-by-package': 'إيرادات العملاء حسب الباقة',

    // ATLAS SUITE

    // User Management
    '/atlas/suite/users/list': 'المستخدمون',
    '/atlas/suite/users/sessions': 'الجلسات',
    '/atlas/suite/audit': 'سجلات التدقيق',
    '/atlas/suite/role': 'إدارة التفويض',
    '/atlas/suite/quick-links': 'روابط سريعة',
    '/atlas/suite/messages': 'إدارة الرسائل',
    '/cms/config/atlasconfig': 'الإعدادات',
  },
};
